import { render } from "./settingDialog.vue?vue&type=template&id=2c5b2f3b&scoped=true"
import script from "./settingDialog.vue?vue&type=script&lang=js"
export * from "./settingDialog.vue?vue&type=script&lang=js"

import "./settingDialog.vue?vue&type=style&index=0&id=2c5b2f3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5b2f3b"]])

export default __exports__